import { render, staticRenderFns } from "./gscInvoiceAdd.vue?vue&type=template&id=0b5f49a2"
import script from "./gscInvoiceAdd.vue?vue&type=script&lang=js"
export * from "./gscInvoiceAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports